import {MouseEventHandler, ReactNode} from 'react';
import Box from '@mui/material/Box';
import {SxProps, Theme} from '@mui/material/styles';
import {kit, radius} from './tokens';

type CardRadius = 'md' | 'lg';
type CardPadding = 'sm' | 'md' | 'lg';

interface CardProps {
  children: ReactNode;
  // Corner radius token: 'md' (12, default) or 'lg' (16).
  radius?: CardRadius;
  // Inner padding preset: sm 12 / md 16 (default) / lg 24.
  padding?: CardPadding;
  // When set, the card is clickable and gets a hover lift.
  onClick?: MouseEventHandler<HTMLDivElement>;
  sx?: SxProps<Theme>;
}

const PADDING: Record<CardPadding, number> = {sm: 12, md: 16, lg: 24};

// White rounded surface with a hairline kit border -- the base container every
// redesigned card sits on (web port of the mobile kit Card).
const Card = ({
  children,
  radius: radiusKey = 'md',
  padding = 'md',
  onClick,
  sx,
}: CardProps) => (
  <Box
    onClick={onClick}
    sx={[
      {
        backgroundColor: '#FFFFFF',
        border: `1px solid ${kit.line}`,
        borderRadius: `${radius[radiusKey]}px`,
        padding: `${PADDING[padding]}px`,
      },
      onClick
        ? {
            cursor: 'pointer',
            transition: 'transform 120ms ease, box-shadow 120ms ease',
            '&:hover': {
              transform: 'translateY(-2px)',
              boxShadow: '0 6px 16px rgba(19, 33, 46, 0.08)',
            },
          }
        : {},
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}>
    {children}
  </Box>
);

export default Card;
